import { Button, Grid2 } from "@mui/material";
import { GoogleMap, useJsApiLoader, DirectionsRenderer, Polygon, DrawingManager } from '@react-google-maps/api';
import React, { useEffect, useRef, useState } from "react";
import DrawIcon from '@mui/icons-material/Draw';
import DeleteIcon from '@mui/icons-material/Delete';

const CommonGeofence = (props) => {
    const geofence = props.geofence ?? null;
    const onUpdatePolygon = props.onUpdatePolygon;
    const zoneType = props.zoneType;
    const geofenceType = props.geofenceType;
    const setNullGeofence = props.setNullGeofence;

    const [mainGeofence, setMainGeofence] = useState([]);
    const [isPolygonVisible, setIsPolygonVisible] = useState(true);
    const [drawingMode, setDrawingMode] = useState(false);
    const [polygonPath, setPolygonPath] = useState([]);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [geocenter, setGeocenter] = useState({});
    const mapRef = useRef(null);

    const drawingManagerRef = useRef(null);
    const drawnPolygonRef = useRef(null); //reference to the polygon that is drawn on the map
    // const { isLoaded } = useJsApiLoader({
    //     id: 'google-map-script',
    //     googleMapsApiKey: 'YOUR_GOOGLE_MAPS_API_KEY',
    //     libraries: ['drawing'],
    // });

    const containerStyle = { width: '100%', height: '460px' };

    useEffect(() => {
        if (geofence) {
            console.log("Geofence received:", geofence);
            setMainGeofence(geofence);
            const geocenter = {
                lat: geofence.reduce((sum, point) => sum + point.x, 0) / geofence.length,
                lng: geofence.reduce((sum, point) => sum + point.y, 0) / geofence.length,
            };
            console.log("Geocenter received:", geocenter);
            setGeocenter(geocenter);
        }
    }, [geofence]);

    useEffect(() => {
        if (mainGeofence && mainGeofence.length > 0 && mapLoaded && window.google) {
            // console.log("Fitting bounds with geofence:", mainGeofence);
            try {
                const bounds = new window.google.maps.LatLngBounds();
                let validPointsFound = false;
                console.log("Fitting bounds with geofence:", mainGeofence);
                
                mainGeofence.forEach((point) => {
                    // Handle both x,y and lat,lng formats
                    const lat = point.x !== undefined ? Number(point.x) : 
                             (point.lat !== undefined ? Number(point.lat) : null);
                    const lng = point.y !== undefined ? Number(point.y) : 
                             (point.lng !== undefined ? Number(point.lng) : null);
                    
                    // Only extend bounds with valid coordinates
                    if (lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng)) {
                        bounds.extend({ lat, lng });
                        validPointsFound = true;
                    } else {
                        console.error("Invalid point skipped in bounds calculation:", point);
                    }
                });
                const geocenter = {
                    lat: mainGeofence.reduce((sum, point) => sum + point.x, 0) / mainGeofence.length,
                    lng: mainGeofence.reduce((sum, point) => sum + point.y, 0) / mainGeofence.length,
                };
                console.log("Geocenter received:", geocenter);
                setGeocenter(geocenter);
                
                // Only fit bounds if we found valid points
                if (validPointsFound) {
                    mapRef.current.fitBounds(bounds);
                } else {
                    console.warn("No valid points found for bounds calculation");
                }
            } catch (error) {
                console.error("Error fitting bounds:", error);
            }
        }
    }, [mainGeofence, mapLoaded]);

    const onLoad = React.useCallback((map) => {
        mapRef.current = map;
        setMapLoaded(true);
    }, []);

    const handlePolygonClick = () => {
        setSelectedPolygon(selectedPolygon ? null : mainGeofence);
    };

    // const handleDrawPolygon = () => {
    //     setDrawingMode(true);
    //     if (drawingManagerRef.current) {
    //         drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
    //     }
    // };

    // const handleUpdatePolygon = () => {
    //     if (onUpdatePolygon && polygonPath) {
    //         onUpdatePolygon(polygonPath);
    //     }
    // };

    const handleDeletePolygon = () => {
        // Delete the selected polygon
        setPolygonPath([]);
        setMainGeofence([]);
        setIsPolygonVisible(false);
        setNullGeofence(true);
        console.log('terue')
        setSelectedPolygon(null);  // Reset the selection
        //deleting the polygon from the map after hitting the delete icon
        if (drawnPolygonRef.current) {
            drawnPolygonRef.current.setMap(null);
            drawnPolygonRef.current = null;
        }
    };
        
    const onLoadDrawingManager = (drawingManager) => {
        drawingManagerRef.current = drawingManager;
    };

    const onPolygonComplete = (polygon) => {
        const path = polygon.getPath().getArray();
        const coordinates = path.map(latLng => ({
            lat: latLng.lat(),
            lng: latLng.lng(),
        }));
        setPolygonPath(coordinates);
        setDrawingMode(false);  // Disable drawing mode after polygon is drawn
        // console.log('path = ', coordinates);
    };

    const handleDrawPolygon = () => {
        // if (!isLoaded || !window.google) {
        //     console.error("Google Maps API not loaded yet");
        //     return;
        // }
        setDrawingMode(true);
        if (drawingManagerRef.current) {
            drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON);
        }
    };
    const handleUpdatePolygon = () => {
        if (onUpdatePolygon && polygonPath) {
            onUpdatePolygon(polygonPath); // Call the parent function with selected polygon
        }
    };
        

    // Determine if drawing tools should be disabled (when zoneType is 4 and geofenceType is not set)
    const isToolsDisabled = zoneType == 4 && !geofenceType;
    
    return (
        <Grid2>
            <Grid2 item container spacing={2}>
                <Grid2 item>
                    {/* {selectedPolygon && ( */}
                        <Button
                            variant="contained"
                            color="danger"
                            onClick={handleDeletePolygon}
                            style={{ marginTop: '5px', opacity: isToolsDisabled ? 0.2 : 1 }}
                            disabled={isToolsDisabled}
                        >
                            <DeleteIcon/>
                        </Button>
                    {/* )} */}
                </Grid2>

                <Grid2 item>
                    {/* {selectedPolygon && ( */}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleDrawPolygon}
                            style={{ marginTop: '5px', opacity: isToolsDisabled ? 0.2 : 1 }}
                            disabled={isToolsDisabled}
                        >
                            <DrawIcon/>
                        </Button>
                    {/* )} */}
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleUpdatePolygon}
                        style={{ marginTop: '5px', opacity: isToolsDisabled ? 0.5 : 1 }}
                        disabled={isToolsDisabled}
                    >
                        Update
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={
                        {
                            lat : geocenter.lat ? geocenter.lat : 28.644800,
                            lng : geocenter.lng ? geocenter.lng : 77.216721
                        }   
                    }
                    zoom={8}
                    onLoad={onLoad}
                >
                    {drawingMode && (
                        <DrawingManager
                            onLoad={(drawingManager) => (drawingManagerRef.current = drawingManager)}
                            onPolygonComplete={(polygon) => {
                                drawnPolygonRef.current = polygon;
                                const path = polygon.getPath().getArray();
                                const coordinates = path.map((latLng) => ({
                                    lat: latLng.lat(),
                                    lng: latLng.lng(),
                                }));
                                setPolygonPath(coordinates);
                                const geocenter = {
                                    lat: coordinates.reduce((sum, point) => sum + point.lat, 0) / coordinates.length,
                                    lng: coordinates.reduce((sum, point) => sum + point.lng, 0) / coordinates.length,
                                };
                                setGeocenter(geocenter);
                                setDrawingMode(false);
                            }}
                            drawingMode={window.google.maps.drawing.OverlayType.POLYGON}
                        />
                    )}
                    {mapLoaded && isPolygonVisible && mainGeofence && mainGeofence.length > 0 && (
                        <Polygon
                            paths={mainGeofence.map((point) => {
                                // Log each point to debug
                                // console.log("Processing point for Polygon:", point);
                                
                                // Handle both x,y and lat,lng formats
                                const lat = point.x !== undefined ? Number(point.x) : 
                                         (point.lat !== undefined ? Number(point.lat) : null);
                                const lng = point.y !== undefined ? Number(point.y) : 
                                         (point.lng !== undefined ? Number(point.lng) : null);
                                
                                // Skip invalid coordinates
                                if (lat === null || lng === null || isNaN(lat) || isNaN(lng)) {
                                    console.error("Invalid coordinates detected:", point);
                                    return null;
                                }
                                
                                return { lat, lng };
                            }).filter(Boolean)} // Filter out any null values
                            options={{
                                fillColor: "rgba(255, 0, 0, 0.3)",
                                fillOpacity: 0.4,
                                strokeColor: "red",
                                strokeOpacity: 1,
                                strokeWeight: 2,
                            }}
                            onClick={handlePolygonClick}
                        />
                    )}
                </GoogleMap>
            </Grid2>
        </Grid2>
    );
};

export default CommonGeofence;
